import { motion } from "framer-motion";

export const PageHeader = ({ title, subtitle, children }) => {
  return (
    <header className="glass-header border-b border-black/5 sticky top-0 z-40">
      <div className="px-6 md:px-10 py-5 flex items-center justify-between gap-4">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 24 }}
        >
          <h1 className="font-heading text-2xl md:text-3xl font-bold tracking-tight text-[#1D1D1F]">
            {title}
          </h1>
          {subtitle && <p className="text-sm text-[#86868B] mt-0.5">{subtitle}</p>}
        </motion.div>
        {children && <div className="flex items-center gap-2 shrink-0">{children}</div>}
      </div>
    </header>
  );
};

export default PageHeader;
